import React from "react";
import { User } from "lucide-react";

// Single reusable avatar: real photo → initials → generic icon fallback.
// Used across Navbar, Professional Profile, Dashboard header and the company
// preview so there is one visual source of truth for "who is this candidate".
export function CandidateAvatar({ name, picture, size = 40, rounded = "full" }) {
  const initials = (name || "").trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();
  const radius = rounded === "full" ? "50%" : "20px";
  return (
    <div
      data-testid="candidate-avatar"
      style={{
        width: size, height: size, borderRadius: radius, flexShrink: 0, overflow: "hidden",
        background: "#028CF8", display: "flex",
        alignItems: "center", justifyContent: "center", color: "white", fontWeight: 700,
        fontSize: Math.max(11, Math.round(size * 0.35)), fontFamily: "Poppins, sans-serif",
      }}
    >
      {picture ? (
        <img src={picture} alt={name || "Avatar"} className="w-full h-full object-cover" />
      ) : initials ? (
        initials
      ) : (
        <User style={{ width: size * 0.5, height: size * 0.5 }} />
      )}
    </div>
  );
}
